<div class="col-lg-11 col-md-11 col-sm-12 shadow-lg rounded mt-5 ms-md-5 mb-3">
    <dn-progress-spinner *ngIf="initializing"></dn-progress-spinner>
    <div class="" *ngIf="!initializing">
        <confirm-email 
            [data]="translationData"
            [confirmEmailContent]="contentRef"
            [confirmEmailTitle]="titleRef"
            [updateTranslation]="!initializing"
            [headerText]="headerText"
            > 
        </confirm-email>
    </div>
    <div class="row smaller-font" *ngIf="showForgotCredentials()">
        <div class="col-sm mt-n5 d-flex justify-content-center">
            <a href class="link" (click)="onForgotUsername($event)">Forgot username</a>
            <span class="mx-1">|</span>
            <a href class="link" (click)="onForgotPassword($event)">Forgot password</a>
        </div>
    </div>
</div>